module.exports = __webpack_public_path__ + "static/img/8.bd16966.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/8.png
// module id = cTAZ
// module chunks = 0